import React from "react";

// The two pills every page carries: one to the other quotes page, one to
// Rory's own page. Plain links, so each page arrives with its own title,
// description and structured data.
const HeroLink = ({ to, children }: { to: string; children: React.ReactNode }) => (
  <div className="rq-hero__links">
    <a href={to} className="rq-pill">
      {children}
    </a>
    <a href="/thought-leaders/rory-sutherland" className="rq-pill">
      About Rory
    </a>
  </div>
);

export default HeroLink;
